import type { EventEntry } from './backend';

export class EventScheduler {
  private events: Array<EventEntry & { processed?: number }> = [];

  private timeUnitsToProcessTillNextUpdate = 0;

  addEvents(events: EventEntry[]) {
    this.events.push(...events);
  }

  markTimeUnitsToProcessTillNextUpdate(gameTime: number) {
    this.timeUnitsToProcessTillNextUpdate = this.timeUnitsLeft(gameTime);
  }

  getTimeUnitsToProcessTillNextUpdate() {
    return this.timeUnitsToProcessTillNextUpdate;
  }

  getRelevantEvents(
    lastQueryGameTime: number,
    gameTime: number
  ): Array<EventEntry & { processed?: number }> {
    const relevantEvents = this.events.filter(
      (e) => !(e.end_time < lastQueryGameTime || e.start_time > gameTime)
    );

    return relevantEvents;
  }

  cleanEvents(gameTime: number) {
    const oldEvents = this.events.filter((e) => e.end_time <= gameTime);

    for (const e of oldEvents) {
      if (!e.processed) {
        console.log(
          'Event not processed',
          e,
          Object.keys(e.data)[0],
          e.start_time === e.end_time,
          e.start_time === gameTime
        );
      }
    }

    this.events = this.events.filter((e) => e.end_time > gameTime);
  }

  timeUnitsLeft(gameTime: number) {
    const lastEvent = this.events[this.events.length - 1];
    if (!lastEvent) {
      return 0;
    }

    return Math.max(0, lastEvent.end_time - gameTime);
  }
}

export class GameTime {
  lastDataArrivedAt: number | null = null;
  averageGameUpdateInterval = 1000;

  lastGameTime = 0;
  lastRealTime = Date.now();

  constructor() {}

  initialize() {}

  markDataArrived() {
    const now = Date.now();

    if (this.lastDataArrivedAt === null) {
      this.lastDataArrivedAt = now;
      return;
    }

    this.averageGameUpdateInterval =
      0.9 * this.averageGameUpdateInterval +
      0.1 * (now - this.lastDataArrivedAt);
    this.lastDataArrivedAt = now;

    // console.log(this.averageGameUpdateInterval);
  }

  tick(timeUnitsLeft: number, totalTimeUnitsTillNextUpdate: number) {
    const currentRealTime = Date.now();

    const realTimePassedSinceLastTick = currentRealTime - this.lastRealTime;

    const progressTowardsAllTimeUnitsProcessed = Math.min(
      1,
      realTimePassedSinceLastTick / this.averageGameUpdateInterval
    );

    const gameTimePassed =
      totalTimeUnitsTillNextUpdate * progressTowardsAllTimeUnitsProcessed;

    if (timeUnitsLeft < gameTimePassed) {
      this.lastGameTime += timeUnitsLeft * 0.5;
    } else {
      this.lastGameTime += gameTimePassed;
    }

    this.lastRealTime = currentRealTime;
  }

  getGameTime() {
    return this.lastGameTime;
  }
}
